export const formatFileApiUrlToFileName = fileApiUrl => {
    return (
      fileApiUrl && String(fileApiUrl).split('filename=')[1]
    );
};
  